var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4547 5.41875C11.4109 5.4125 11.3672 5.4125 11.3234 5.41875C10.3547 5.3875 9.58594 4.59375 9.58594 3.61875C9.58594 2.625 10.3922 1.8125 11.3922 1.8125C12.3859 1.8125 13.1984 2.61875 13.1984 3.61875C13.1922 4.59375 12.4234 5.3875 11.4547 5.41875Z",
    fill: "#6D9E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4938 9.75001C12.7938 10.2188 11.8125 10.3938 10.9062 10.275C11.1437 9.76251 11.2687 9.19376 11.275 8.59376C11.275 7.96876 11.1375 7.37501 10.875 6.85626C11.8 6.73126 12.7813 6.90626 13.4875 7.37501C14.475 8.02501 14.475 9.09376 13.4938 9.75001Z",
    fill: "#6D9E3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52266 5.41875C4.56641 5.4125 4.61016 5.4125 4.65391 5.41875C5.62266 5.3875 6.39141 4.59375 6.39141 3.61875C6.39141 2.61875 5.58516 1.8125 4.58516 1.8125C3.59141 1.8125 2.78516 2.61875 2.78516 3.61875C2.78516 4.59375 3.55391 5.3875 4.52266 5.41875Z",
    fill: "#6D9E3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59297 8.59375C4.59297 9.2 4.72422 9.775 4.96172 10.2938C4.08047 10.3875 3.16172 10.2 2.48672 9.75625C1.49922 9.1 1.49922 8.03125 2.48672 7.375C3.15547 6.925 4.09922 6.74375 4.98672 6.84375C4.73047 7.36875 4.59297 7.9625 4.59297 8.59375Z",
    fill: "#6D9E3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 10.4812C8.025 10.475 7.96875 10.475 7.9125 10.4812C6.7625 10.4437 5.84375 9.5 5.84375 8.3375C5.85 7.15 6.80625 6.1875 8 6.1875C9.1875 6.1875 10.15 7.15 10.15 8.3375C10.1437 9.5 9.23125 10.4437 8.075 10.4812Z",
    fill: "#6D9E3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04375 11.775C5.1 12.4063 5.1 13.4438 6.04375 14.0688C7.11875 14.7875 8.88125 14.7875 9.95625 14.0688C10.9 13.4375 10.9 12.4 9.95625 11.775C8.8875 11.0563 7.125 11.0563 6.04375 11.775Z",
    fill: "#6D9E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb);
export default __webpack_public_path__ + "static/media/cb.9f9726fedacd2d79fbb453b8290b704f.svg";
export { ForwardRef as ReactComponent };